import React from 'react'
import { useState,useEffect } from 'react';
import FollowButton from '../../../../components/forms/followButton';
import ApiUrl from '../../../../configTools/apiUrl';
import { Link } from 'react-router-dom';

const Youmayknow = () => {
    const Columns = 6;
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [ymkUser,setymkUser] = useState([]);
    const change_follow = (followto)=>{
        fetch(ApiUrl.API_URL_Follower, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify({
                followtoid : followto
            })
          })
          .then(res=>res.json())
          .then(data =>{
            Refresh();
        });
    }
    const Refresh = ()=>{
      if(User === null){
        fetch(ApiUrl.API_URL_BrandYoumayknow)
        .then(res=>res.json())
        .then(data =>{
            setymkUser(data);
        });
      }
      else{
        fetch(ApiUrl.API_URL_BrandYoumayknow,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            setymkUser(data);
        });
      }
    }
    useEffect(()=>{
        Refresh();
    },[])
  return (
    <div className='public_home_explore_topsearches'>
        <div className='public_home_user_grid_container'>
            <div className='public_home_product_grid_1_title'>
                <div className='public_home_product_grid_1_title_details'>
                    <h4>{'Brands You May Know'}</h4>
                    <p>{'Brands Suggestions'}</p>
                </div>
            </div>
            <div className='public_home_user_grid_users'>
                {
                    ymkUser.slice(0, parseInt(Columns)).map((user,index)=>{
                        return(
                            <div style={{width:String(90/(parseInt(Columns)))+"%", position:"relative",paddingBottom:"30px", borderRadius:"3px", border:"1px solid #2a2a2a"}} key={index}>
                                <div style={{padding:"20px"}}>
                                    <Link to={'/user/'+user.username}>
                                        <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+user.image})`,borderRadius:'50%', overflow:'hidden'}}>
                                            <div className='public_home_product_grid_1_products_item_overlay'></div>
                                        </div>
                                    </Link>
                                    <div className='public_home_product_grid_1_products_item_title'>
                                        <Link to={'/user/'+user.username}><h5>{user.firstname} {user.lastname}</h5></Link>
                                    </div>
                                </div>
                                <div className='public_home_product_grid_1_products_item_button'>
                                {!User &&
                                    <Link to={'/login'}>
                                    <FollowButton Value="Follow"/>
                                    </Link>
                                }
                                {User &&
                                    <FollowButton Value={"Follow"} Action={()=>{
                                    change_follow(user.userid)
                                    }} style={{cursor:"pointer"}}/>  
                                }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </div>
  )
}

export default Youmayknow
